import { HotKeyReserved } from "../../models/fastRepliesHotKeys"

export const FirstKeys = {
    SHIFT: 16,
    CTRL: 17,
    ALT: 18
}

const enterCode = 13
const reservedCharsWithControl = [67, 86, 65, 90, 88, 89, 37, 39, 66, 73, 85, 36, 35, enterCode]
const reservedCharsWithAlt = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57]

export const RUSSIAN_KEYS: { [key: number]: string } = {
    1040: "А",
    1041: "Б",
    1042: "В",
    1043: "Г",
    1044: "Д",
    1045: "Е",
    1046: "Ж",
    1047: "З",
    1048: "И",
    1049: "Й",
    1050: "К",
    1051: "Л",
    1052: "М",
    1053: "Н",
    1054: "О",
    1055: "П",
    1056: "Р",
    1057: "С",
    1058: "Т",
    1059: "У",
    1060: "Ф",
    1061: "Х",
    1062: "Ц",
    1063: "Ч",
    1064: "Ш",
    1065: "Щ",
    1067: "Ы",
    1068: "Ь",
    1069: "Э",
    1070: "Ю",
    1071: "Я",
    1072: "а",
    1073: "б",
    1074: "в",
    1075: "г",
    1076: "д",
    1077: "е",
    1078: "ж",
    1079: "з",
    1080: "и",
    1081: "й",
    1082: "к",
    1083: "л",
    1084: "м",
    1085: "н",
    1086: "о",
    1087: "п",
    1088: "р",
    1089: "с",
    1090: "т",
    1091: "у",
    1092: "ф",
    1093: "х",
    1094: "ц",
    1095: "ч",
    1096: "ш",
    1097: "щ",
    1099: "ы",
    1100: "ь",
    1101: "э",
    1102: "ю",
    1103: "я"
}

export const HOT_KEY_MAP = [
    [1040, 1072, 70],
    [1041, 1073, 188],
    [1042, 1074, 68],
    [1043, 1075, 85],
    [1044, 1076, 76],
    [1045, 1077, 84],
    [1046, 1078, 186],
    [1047, 1079, 80],
    [1048, 1080, 66],
    [1049, 1081, 81],
    [1050, 1082, 82],
    [1051, 1083, 75],
    [1052, 1084, 86],
    [1053, 1085, 89],
    [1054, 1086, 74],
    [1055, 1087, 71],
    [1056, 1088, 72],
    [1057, 1089, 67],
    [1058, 1090, 78],
    [1059, 1091, 69],
    [1060, 1092, 65],
    [1062, 1094, 87],
    [1063, 1095, 88],
    [1064, 1096, 73],
    [1065, 1097, 79],
    [1067, 1099, 83],
    [1068, 1100, 77],
    [1069, 1101, 222],
    [1070, 1102, 190],
    [1071, 1103, 90]
]

export const ReservedCombinations: HotKeyReserved[] = [
    {
        firstKey: FirstKeys.CTRL,
        secondKeys: reservedCharsWithControl
    },
    {
        firstKey: FirstKeys.SHIFT,
        secondKeys: [enterCode]
    },
    {
        firstKey: FirstKeys.ALT,
        secondKeys: reservedCharsWithAlt
    }
]
